import { defaultIconColor } from './constants';
import { useIntl } from 'react-intl';
import { SVGComponentPropsType } from './types';

type PropsType = SVGComponentPropsType & {
  tooltipMessageId?: string;
};

const defaultSize = 24;

export default ({ color = defaultIconColor, size = defaultSize, tooltipMessageId = '', ...props }: PropsType) => {
  const intl = useIntl();

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox={`0 0 ${defaultSize} ${defaultSize}`}
      {...props}
    >
      {tooltipMessageId && <title>{intl.formatMessage({ id: tooltipMessageId })}</title>}
      <g fill={color} fillRule="evenodd">
        <path d="M3 6h2v12H3zM6 6h4v12H6zM11 6h2v12h-2zM15 6h2v12h-2zM18 6h2v12h-2z" />
      </g>
    </svg>
  );
};
